import type { FC } from 'react'
import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface AlertMessageProps {
  message?: string
}

export const AlertMessage: FC<AlertMessageProps> = ({ message }) => {
  if (!message) return null

  return (
    <Alert color="info">
      <Box flexDirection="row" alignItems="center" gap="s8">
        <Icon.Medium icon="pin" color="viridian1000" />
        <Text.Normal>{message}</Text.Normal>
      </Box>
    </Alert>
  )
}
